import { Funcionalidades } from './funcionalidades'

type HasPermission = (permission: string) => boolean

/**
 * HU 865225 — só o Promotor expede o Termo: perfil `mac-perfil-promotor_justica` E a funcionalidade
 * `…termo_entrega_expedir`, a mesma regra do back. Não usa a claim `cargo` (o "Servidor da
 * Promotoria" também vem com cargo PROMOTOR).
 */
export const podeExpedirTermo = (hasPermission: HasPermission): boolean =>
  hasPermission(Funcionalidades.perfil.promotor) &&
  hasPermission(Funcionalidades.oitiva.termoEntrega.expedir)

/**
 * HU 864936 — Servidor e Promotor criam/salvam o Termo. O back não exige role para salvar; a
 * rota do front pede `…termo_entrega_criar`, que precisa estar cadastrada no GCA para o Servidor.
 */
export const podeCriarTermo = (hasPermission: HasPermission): boolean =>
  hasPermission(Funcionalidades.oitiva.termoEntrega.criar)

/**
 * Quem abre a tela do Termo: cria (Servidor) ou expede (Promotor). Aceitar `expedir` evita
 * tirar o acesso do Promotor enquanto `criar` não estiver cadastrada no GCA.
 */
export const PERMISSOES_ABRIR_TERMO = [
  Funcionalidades.oitiva.termoEntrega.criar,
  Funcionalidades.oitiva.termoEntrega.expedir,
]

export const podeAbrirTermo = (hasPermission: HasPermission): boolean =>
  PERMISSOES_ABRIR_TERMO.some(hasPermission)
